import React from 'react'
import { PeopleFill } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'
import EnrolleeName from '../../user/last-first-name'

const Enrollees = ({
    users = []
}) => {
    const { breakpoint, breakpoints } = useViewport()
    const renderEnrollee = (enrollee) => {
        return (
            <div key={enrollee.id} className='ellipsis-truncate'><EnrolleeName user={enrollee} /></div>
        )
    }
    return (
        <div>
            <div>
                <PeopleFill size={30} />
                <span  style={{ paddingLeft: '10px'}}>
                    {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Students Enrolled' : ''} ({users.length})</span>
            </div>
            <div style={{ paddingLeft: '20px', paddingTop: '15px', color: 'rgb( 137, 138, 139)'}}>
                {users.map(renderEnrollee)}
            </div>
        </div>
    )
}

export default Enrollees